function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { getKeys } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
export var TimeType;

(function (TimeType) {
  TimeType["HOUR"] = "hour";
  TimeType["MINUTE"] = "minute";
  TimeType["SECOND"] = "second";
})(TimeType || (TimeType = {}));

export var Time = function (_Emitter) {
  _inherits(Time, _Emitter);

  var _super = _createSuper(Time);

  function Time(part) {
    var _this;

    _classCallCheck(this, Time);

    _this = _super.call(this);
    _this.showHour = true;
    _this.showMinute = true;
    _this.showSecond = true;
    _this.hour = null;
    _this.minute = null;
    _this.second = null;
    _this.root = null;
    _this.value = null;
    _this.hourStep = 1;
    _this.minuteStep = 1;
    _this.secondStep = 1;
    _this.part = part;
    return _this;
  }

  _createClass(Time, [{
    key: "repaintTime",
    value: function repaintTime() {
      this.emit('repaint');
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var _this2 = this;

      getKeys(options).forEach(function (key) {
        if (options[key] !== undefined) {
          Object.assign(_this2, _defineProperty({}, key, options[key]));
        }
      });
    }
  }, {
    key: "updateTime",
    value: function updateTime(time) {
      if (time == null) {
        this.hour = null;
        this.minute = null;
        this.second = null;
      } else {
        var t1 = (time === null || time === void 0 ? void 0 : time.getHours()) || 0;
        var t2 = (time === null || time === void 0 ? void 0 : time.getMinutes()) || 0;
        var t3 = (time === null || time === void 0 ? void 0 : time.getSeconds()) || 0;

        if (this.showHour) {
          this.hour = +t1;
        }

        if (this.showMinute) {
          this.showHour ? this.minute = +t2 : this.minute = +t1;
        }

        if (this.showSecond) {
          if (this.showHour && this.showSecond) {
            this.second = +t3;
          }

          if (!this.showHour && !this.showSecond) {
            this.second = +t1;
          }

          if (this.showHour && !this.showSecond || !this.showHour && this.showSecond) {
            this.second = +t2;
          }
        }
      }

      this.value = time || null;

      if (this.root) {
        this.root.repaint();
      } else {
        this.repaintTime();
      }
    }
  }, {
    key: "getHourOptions",
    value: function getHourOptions() {
      if (!this.showHour) {
        return [];
      }

      return this.generateOptions(24, this.hourStep, this.disabledHours, TimeType.HOUR);
    }
  }, {
    key: "getMinuteOptions",
    value: function getMinuteOptions() {
      if (!this.showMinute) {
        return [];
      }

      return this.generateOptions(60, this.minuteStep, this.disabledMinutes, TimeType.MINUTE);
    }
  }, {
    key: "getSecondOptions",
    value: function getSecondOptions() {
      if (!this.showSecond) {
        return [];
      }

      return this.generateOptions(60, this.secondStep, this.disabledSeconds, TimeType.SECOND);
    }
  }, {
    key: "getCurrentIndex",
    value: function getCurrentIndex(type, options) {
      var currentValue = -1;
      var activeIndex = -1;

      switch (type) {
        case TimeType.HOUR:
          this.hour !== null && (currentValue = this.hour);
          break;

        case TimeType.MINUTE:
          this.minute !== null && (currentValue = this.minute);
          break;

        case TimeType.SECOND:
          this.second !== null && (currentValue = this.second);
          break;
      }

      options.map(function (item, index) {
        if (currentValue === +item.value) {
          activeIndex = index;
        }
      });
      return activeIndex;
    }
  }, {
    key: "onSelect",
    value: function onSelect(type, value) {
      var newValue = this.value || new Date();

      switch (type) {
        case TimeType.HOUR:
          this.hour = value;
          newValue.setHours(value);
          break;

        case TimeType.MINUTE:
          this.minute = value;
          newValue.setMinutes(value);
          break;

        case TimeType.SECOND:
          this.second = value;
          newValue.setSeconds(value);
          break;
      }

      this.value = newValue;
      this.repaintTime();

      if (this.showHour && this.hour == null || this.showMinute && this.minute == null || this.showSecond && this.second == null) {
        return;
      }

      this.value && this.emit('value-change', this.value);
    }
  }, {
    key: "generateOptions",
    value: function generateOptions(length, step, disabledFunc, type) {
      var arr = [];

      for (var i = 0; i < length; i += step) {
        arr.push({
          value: this.padLef(i),
          disabled: disabledFunc(i) || !!this.root && this.root.compare(i, type, this.part)
        });
      }

      return arr;
    }
  }, {
    key: "disabledHours",
    value: function disabledHours(v) {
      return false;
    }
  }, {
    key: "disabledMinutes",
    value: function disabledMinutes(v) {
      return false;
    }
  }, {
    key: "disabledSeconds",
    value: function disabledSeconds(v) {
      return false;
    }
  }, {
    key: "padLef",
    value: function padLef(v) {
      return v >= 10 ? "".concat(v) : "0".concat(v);
    }
  }]);

  return Time;
}(Emitter);